import { render } from "./SellersAddView.vue?vue&type=template&id=243e6b6e"
import script from "./SellersAddView.vue?vue&type=script&lang=js"
export * from "./SellersAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__